import $api from "../../axios/chat/index";

export default function useCs() {
    const url = new URL(window.location.href);
    const cc = url.searchParams.get("token");
    const csIdKey = `csId-${cc}`

    // 修改本地客服id
    const editCsid = (value) => {
        localStorage.setItem(csIdKey, value)
    }

    // 获取客服id => id
    const getCsId = async () => {
        let csId = localStorage.getItem(csIdKey)

        if (csId && Number(csId) !== 0) {
            return csId
        }

        const res = await $api.getOnlineKf()
        if (res.code === 200) {
            const {snowflake_id, online} = res.data
            csId = String(snowflake_id)
            Number(csId) !== 0 && editCsid(csId)
        }

        return csId
    }

    // 查询本地 - 是否已存在该客服
    const queryLocalStorageKF = (csId) => {
        const kf = localStorage.getItem("kf-" + csId)
        return kf ? JSON.parse(kf) : false
    }

    // 获取客服详情
    const getKefu = async (news = false) => {
        const kefu_sfid = await getCsId()

        // const localKf = queryLocalStorageKF(kefu_sfid)
        // if (localKf && !news) {
        //     return localKf
        // }

        if (kefu_sfid !== 0) {
            const res = await $api.getKefuInfo({kefu_sfid})
            if (res.code === 200) {
                //http://dev.manager.needke.com
                res.data.avatar = process.env.REACT_APP_API + "storage" + res.data.avatar
                localStorage.setItem("kf-" + kefu_sfid, JSON.stringify(res.data))
                return res.data
            } else {
                return new Error(res)
            }
        }

        return {}
    }

    return {
        getCsId,
        getKefu,
        editCsid
    }
}
